import { z } from "zod";

const translationPath = "4uESign.page.automations.emailSendRules.errors.";

export const emailSendRuleSchema = z
  .object({
    id: z.string().optional(),
    name: z
      .string()
      .trim()
      .min(1, translationPath + "name"),
    initialDate: z.date({
      required_error: translationPath + "initial_date",
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({
      required_error: translationPath + "end_date",
      invalid_type_error: translationPath + "end_date",
    }),
    subject: z
      .string()
      .trim()
      .min(1, translationPath + "subject"),
    body: z
      .string()
      .trim()
      .min(1, translationPath + "body"),
    enable: z.boolean(),
  })
  .superRefine((value, context) => {
    if (value.endDate < value.initialDate) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: translationPath + "end_date_less",
      });
    }
  });

export type TEmailSendRuleForm = z.infer<typeof emailSendRuleSchema>;
